export default __webpack_public_path__ + "static/media/lewis_of_man.c25c9bf3.png";